import { Currency } from "@redotech/money/currencies";
import { CustomerPortalAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { ReturnItemParams } from "@redotech/redo-customer-portal-shared/util";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { ItemDetail } from "../../shared-components/item-detail";
//Todo support multiple shipments
export function ReturnItems({
  products,
  currency,
  header,
  settings,
}: {
  products: ReturnItemParams[] | undefined;
  currency: Currency;
  header: string;
  settings: CustomerPortalAppSettings | undefined;
}) {
  return (
    <Flex flexDirection="column" gap="xl">
      <Text as="h2" fontSize="lg" fontWeight="semibold">
        {header}
      </Text>
      {products?.map((item, i) => (
        <ItemDetail item={item} key={item.id} settings={settings} />
      ))}
    </Flex>
  );
}
